module.exports = __webpack_public_path__ + "img/collection-weddingRingsCeramic.9868094.webp";